// `Symbol.isConcatSpreadable` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.isconcatspreadable
require('../internals/define-well-known-symbol')('isConcatSpreadable');